import { useEffect, useState } from "react";

import { api } from "../../lib/api";
import { List } from "../../types/resquest";
import { getToken } from "../../storage/auth";
import { CargoTreatmentsProps } from "../../types/cargoTratament";
import {DataTableUtils} from "../../components/DataTable/DataTableUtils";

interface IList {
  keyword?: string;
  page?: number;
  limit?: number;
  sort?: string;
}

const entity = "cargoTreatments";
const dataTableUtils = new DataTableUtils(entity);

export const useList = (
  params?: IList,
  token?: string
): { data: CargoTreatmentsProps[]; meta: List; isLoading: boolean } => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<CargoTreatmentsProps[]>([
    {} as CargoTreatmentsProps,
  ]);
  const [meta, setMeta] = useState<List>({} as List);
  useEffect(() => {
    if (token) {
      (async function () {
        setIsLoading(true);
        const response = await dataTableUtils.findPaginate(params);
        const {total, data, currentPage, totalPages, limit} = response.data;
        setData(data);
        setMeta((prevState) => ({
          ...prevState,
          total,
          totalPages,
          limit,
          currentPage,
        }));
        setIsLoading(false)
      })();
    }
  }, [params, token]);

  return { data, meta, isLoading };
};

export const update = async (
  id: number | string,
  currency?: CargoTreatmentsProps
): Promise<CargoTreatmentsProps> => {
  const token = getToken();
  const { data } = await api.patch(`/${entity}/${id}`, currency, {
    headers: { authorization: `Bearer ${token}` },
  });

  return data;
};
export const deleteCargo = async (
  id: number | string
): Promise<CargoTreatmentsProps> => {
  const token = getToken();
  const { data } = await api.delete(`/${entity}/${id}`, {
    headers: { authorization: `Bearer ${token}` },
  });

  return data;
};

export const isInUse = async (id: number | string): Promise<any> => {
  const token = getToken();
  const { data } = await api.get(`/${entity}/isInUse/${id}`, {
    headers: { authorization: `Bearer ${token}` },
  });

  return data;
};

export const create = async (currency: any): Promise<any> => {
  const token = getToken();
  const { data } = await api.post(`/${entity}`, currency, {
    headers: { authorization: `Bearer ${token}` },
  });

  return data;
};

export const createCopy = async (
  currency: CargoTreatmentsProps[]
): Promise<CargoTreatmentsProps[]> => {
  const token = getToken();
  const { data } = await api.post(`/${entity}/copy`, currency, {
    headers: { authorization: `Bearer ${token}` },
  });

  return data;
};

export const exportAll = async (params: any) => {
  let xlsxData = [
    { label: "Id", value: "ID_TRATAMENTO_CARGA" },
    { label: "Description", value: "DSC_TRAT_CARGA" },
    { label: "Company abbreviation", value: "GE_SIGLA_EMPRESA" },
    { label: "Center abbreviation", value: "GC_DSC_SIGLA" },
    { label: "Center name", value: "GC_NOME_CENTRO" },
    {
      label: "Status",
      value: (row: any) => (row.ATIVO ? "Active" : "Inactive"),
    },
  ]
  await dataTableUtils.exportAll({params, xlsxData, filename: "CargoTreatment"});
};

export const getCenters = async (center) => {
  if(!center?.id) return;
  const { data } =  await dataTableUtils.findPaginate({
    ID_CENTRO: center.id,
    ATIVO: true,
    page: 1
  });
  return data;
}